/**
 * BOTTOM GENERAL INITS
 * ADVICE COOKIES
 */

import { CookiesAdvice } from "./cookiesAdvice";


export class CookieInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        // Init and setup cookies advice message pannel [cookieName, expiryDays]
        new CookiesAdvice('cookiesAdvice', 365);
    }
}
